import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formValidated, setFormValidated] = useState({
    workspaceNameCheck: true,
    accountIdCheck: true,
    accountUserCheck: true,
    serviceAccountKeyCheck: true,
    clientIdCheck: true
  });
  const ValidatedInputData = [
    { name: "workspaceName", type: "string", minLength: 3, maxLength: 31 },
    { name: "accountId", type: "email", minLength: 0 },
    { name: "accountUser", type: "email", minLength: 0 },
    { name: "serviceAccountKey", type: "string", minLength: 0 },
    { name: "clientId", type: "number", minLength: 11, maxLength: 31 }
  ];
  const isFormValid = formValidation.isFormValid(
    ["workspaceName", "accountId", "accountUser", "serviceAccountKey", "clientId"],
    formData
  );
  const formSubmit = (event) => {
    const errors = [];
    const email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const number = /^[0-9\b]+$/;
    ValidatedInputData.forEach((data) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      if (data.name === "workspaceName" && (((_b = (_a = formData[data.name]) == null ? void 0 : _a.value) == null ? void 0 : _b.length) <= data.minLength || ((_d = (_c = formData[data.name]) == null ? void 0 : _c.value) == null ? void 0 : _d.length) >= data.maxLength)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      } else if (data.type === "email" && !email.test((_e = formData[data.name]) == null ? void 0 : _e.value)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      } else if (data.name === "clientId" && (!number.test((_f = formData[data.name]) == null ? void 0 : _f.value) || ((_h = (_g = formData[data.name]) == null ? void 0 : _g.value) == null ? void 0 : _h.length) <= data.minLength || ((_j = (_i = formData[data.name]) == null ? void 0 : _i.value) == null ? void 0 : _j.length) >= data.maxLength)) {
        errors.push(data.name);
        setFormValidated((prevData) => ({
          ...prevData,
          [`${data.name}Check`]: false
        }));
      }
    });
    if (errors.length === 0) {
      onSubmit(event);
    }
  };
  const fieldChange = (event, value) => {
    if (event) {
      setFormValidated((prevData) => ({
        ...prevData,
        [value]: true
      }));
      onChange(event);
    }
  };
  const onFileUpload = (e, validationKey) => {
    e.persist();
    setFormValidated((prevData) => ({
      ...prevData,
      [validationKey]: true
    }));
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = formData.serviceAccountKey && formData.serviceAccountKey.fileName ? `Currently using file: ${formData.serviceAccountKey.fileName}.` : "Service account key p12.";
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: (e) => formSubmit(e), buttonContent: "Proceed", disabled: isFormValid, title: "", description: "" }, /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "workspaceName",
      type: "text",
      fieldData: formData.workspaceName,
      onChange: (e) => fieldChange(e, "workspaceNameCheck"),
      placeholder: "Input Name",
      label: "Input Name",
      autoComplete: "off",
      help: "Select a name of your new input that describes it.",
      required: true
    }
  ), !formValidated.workspaceNameCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "clientId" }, "Name must be between 4 to 30 characters"), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "clientId",
      type: "text",
      fieldData: formData.clientId,
      onChange: (e) => fieldChange(e, "clientIdCheck"),
      label: "Client ID",
      help: "The Client ID of the workspace to which the logs belong.",
      autoComplete: "off",
      required: true
    }
  ), !formValidated.clientIdCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "accountId" }, "Client ID must only be numbers between 12 to 30 characters"), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "accountId",
      type: "text",
      fieldData: formData.accountId,
      onChange: (e) => fieldChange(e, "accountIdCheck"),
      label: "Service Account ID",
      help: "The Service Account ID of the workspace to which the logs belong.",
      autoComplete: "off",
      required: true
    }
  ), !formValidated.accountIdCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "accountUser" }, "Enter a valid email ID"), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "accountUser",
      type: "text",
      onChange: (e) => fieldChange(e, "accountUserCheck"),
      fieldData: formData.accountUser,
      help: "The account user email of your workspace.",
      label: "Account User Email",
      required: true
    }
  ), !formValidated.accountUserCheck && /* @__PURE__ */ React.createElement("label", { htmlFor: "serviceAccountKey" }, "Enter a valid email ID"), /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "serviceAccountKey",
      type: "file",
      onChange: (e) => onFileUpload(e, "serviceAccountKeyCheck"),
      fieldData: formData.serviceAccountKey,
      label: "Service Account key",
      help: accountKeyHelpText,
      accept: ".p12",
      required: true
    }
  ));
};
export default StepAuthorize;
